import React, { useState } from 'react';
import TextField from '@mui/material/TextField';

const TextFieldEmail = ({ subject, validSubject, setSubject }) => {
  const methos = {
    handleChange: (e) => {
      setSubject(e);
    },
  };
  return (
    <div>
      <TextField
        id="outlined-basic"
        label="ชื่อเรื่อง"
        variant="outlined"
        value={subject}
        onChange={(e) => methos.handleChange(e.target.value)}
        error={validSubject}
        helperText={validSubject ? 'กรุณากรอกชื่อเรื่อง' : ''}
        sx={{
          '& label': {
            top: 0,
            left: 4,
            bgcolor: 'background.paper',
            px: 1,
            transform: 'translateY(-50%)',
            fontSize: '15px',
          },
          '& input': {
            height: '5px',
            border: '1px solid rgba(0, 0, 0, 0)',
          },
          width: '100%',
        }}
      />
    </div>
  );
};

export default TextFieldEmail;
